import styled from 'styled-components';
import { AppStyledProps } from '../../../../../../../types';

type T = AppStyledProps;

export const HeaderStyled = styled.div<T>`
  display: flex;
  justify-content: space-between;

  h2 {
    font-size: 1.25em;
  }

  ${({ theme }) =>
    theme.device.mobile &&
    `
  `}
`;
